'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dId$0024 from "./presto.types$-Rule-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Rules$$anon$1(outer) {
  this.bw9 = null;
  this.bw7 = null;
  this.bw8 = false;
  this.bw5 = null;
  this.bw6 = false;
  this.bwa = false;
  this.bwb = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bw9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Rules$$anon$1 as $c_Lpresto_Rules$$anon$1 };
$p = $c_Lpresto_Rules$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Rules$$anon$1;
/** @constructor */
function $h_Lpresto_Rules$$anon$1() {
}
export { $h_Lpresto_Rules$$anon$1 as $h_Lpresto_Rules$$anon$1 };
$h_Lpresto_Rules$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bw9;
});
$p.t = (function() {
  if ((!this.bw8)) {
    this.bw7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bw8 = true;
  }
  return this.bw7;
});
$p.ag = (function() {
  if ((!this.bw6)) {
    this.bw5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dId$0024.$m_Lpresto_types$RuleId$().a36(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bw6 = true;
  }
  return this.bw5;
});
$p.v = (function() {
  if ((!this.bwb)) {
    this.bwa = false;
    this.bwb = true;
  }
  return this.bwa;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Rules$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Rules$$anon$1, "presto.Rules$$anon$1", ({
  Qq: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Rules$$anon$1 as $d_Lpresto_Rules$$anon$1 };
//# sourceMappingURL=presto.-Rules$$anon$1.js.map
